const Auth = {
    install (Vue, options) {
        var router = options.router

        var RETRIEVING = false

        var auth = new Vue({
            data () {
                return {
                    user: {},
                    token: false
                }
            },
            methods: {
                setToken: function (token, expiration) {
                    localStorage.setItem('token', token)
                    localStorage.setItem('expiration', expiration)
                    Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
                    Vue.axios.defaults.baseURL = 'https://' + process.env.API_URL + '/' + process.env.API_VERSION
                    this.token = token
                    Vue.nextTick()
                    this.getUser()
                    this.distributeToken(token, expiration)
                },
                getToken: function () {
                    var token = localStorage.getItem('token')
                    var expiration = localStorage.getItem('expiration')

                    if (!token || !expiration) {
                        return false
                    }

                    if (Date.now() > parseInt(expiration)) {
                        this.destroyToken()
                        return false
                    } else {
                        this.token = token
                        this.distributeToken(token, expiration)
                        return token
                    }
                },
                destroyToken: function () {
                    this.user = {}
                    this.token = false
                    localStorage.removeItem('token')
                    localStorage.removeItem('expiration')

                    this.distributeToken(false, false)
                },
                isAuthenticated: function () {
                    return this.getToken()
                },
                getUser: function (cb) {
                    RETRIEVING = true

                    return new Promise((resolve, reject) => {
                        if (typeof this.user.uuid !== 'undefined') {
                          return resolve(this.user)
                        }
            
                        Vue.axios.get('/user')
                          .then(response => {
                            this.user = response.data
            
                            resolve(this.user)
                          })
                          .catch((err) => {
                              console.log(err)
                            // Vue.$notify.error('Error retreiving user info')
                          })
                      })
                },
                can: function (permission) {
                    if (typeof this.user.role === 'undefined' && !RETRIEVING) {
                      this.getUser()
                        .then(user => {
                          return this.checkPermissions(permission)
                        })
                    } else {
                      if (this.user.role && this.user.role.slug === 'portal_admin') {
                        return true
                      }
                      return this.checkPermissions(permission)
                    }
                  },
                  checkPermissions: function (permission) {
                    if (typeof this.user.role === 'undefined') {
                      return false
                    }
                    if (this.user.role.slug === 'portal_admin') {
                      return true
                    }
          
                    let can = false
          
                    if (typeof this.user.role !== 'undefined' && typeof this.user.role.permissions !== 'undefined') {
                      this.user.role.permissions.map(perm => {
                        if (perm.slug === permission) {
                          can = true
                        }
                      })
                    }
                    return can
                  },
                  distributeToken (token, expiration) {
                    let win = document.getElementById('website-iframe')

                    if (!win) {
                        return
                    }

                    win = win.contentWindow

                    let obj = {
                        token: token,
                        expiration: expiration
                    };
                    
                    win.postMessage(JSON.stringify({key: 'auth', data: obj}), '*')
                }
            }
        })

        Vue.mixin({
            computed: {
                isAuthenticated: function () {
                    return auth.token
                },
                user: function () {
                    if (!auth.getToken()) {
                        return null
                    }
                    return auth.user
                },
                userRole: function (slug) {
                    if (typeof auth.user.role === 'undefined') {
                        return false
                    }
            
                    return auth.user.role.slug
                }
            }
        })

        if (auth.getToken()) {
            Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + auth.getToken()
            Vue.axios.defaults.baseURL = 'https://' + process.env.API_URL + '/' + process.env.API_VERSION

            auth.getUser()
        }

        var authCheck = function () {
            setTimeout(() => {
                if (!auth.getToken()) {
                    router.push('/login')
                    return
                }
                Vue.axios.get('/user')
                    .then(res => {

                    })
                    .catch(() => {
                        auth.destroyToken()
                        router.push('/login')
                    })
                    .finally(() => {
                        if (auth.getToken()) {
                            authCheck()
                        }
                    })
            }, 10000)
        }

        // authCheck()

        Vue.prototype.$auth = Vue.auth = auth
    }
}

export default Auth



//////////////////
// WEBPACK FOOTER
// ./prompts/packages/auth/Auth.js
// module id = null
// module chunks = 